import React from "react";
import ReactHighcharts from "react-highcharts";
import {
  SEASONS_ORDERED,
  COLORS,
  BATTLEPASSES_ORDERED,
  LTMS,
} from "../../types";

export default ({ userData, relativeView, totalPacks, heirloomRecord }) => {
  const {
    accountPacks,
    seasonalPacks,
    miscPacks,
    twitchPrime,
    purchasedPacks,
    seasonalQuestPacks,
    seasonalLTMs,
  } = userData;
  const softMax = !!heirloomRecord ? heirloomRecord + 500 : 500;

  const config = {
    chart: {
      type: "bar",
      backgroundColor: "#13131378",
      marginLeft: 1,
      marginRight: 1,
    },
    caption: false,
    credits: {
      enabled: false,
    },
    legend: {
      itemStyle: {
        color: "#ccc",
      },
      itemHoverStyle: {
        color: "#fff",
      },
      itemHiddenStyle: {
        color: "#444",
      },
      reversed: true,
    },
    plotOptions: {
      bar: {
        borderColor: "transparent",
      },
      series: {
        dataLabels: {
          enabled: true,
          inside: true,
          align: "right",
          verticalAlign: "top",
        },
        stacking: "normal",
      },
    },
    series: [] /* dynamically generated */,
    title: false,
    xAxis: {
      allowDecimals: false,
      categories: ["Apex Packs"],
      floor: 0,
      left: 0,
      minorTicks: true,
    },
    yAxis: {
      gridLineColor: "#333",
      max: undefined,
      min: 100,
      plotLines: [
        {
          color: COLORS.HEIRLOOM,
          label: {
            text: `Next Heirloom: ${softMax}`,
            x: -14,
            style: {
              color: COLORS.HEIRLOOM,
              fontWeight: "bold",
            },
          },
          value: softMax,
          width: 2,
          zIndex: 3,
        },
        // user's progress plotline is dynamically added so it doesn't load
        // at the "0" position
      ],
      softMin: 0,
      softMax: relativeView ? softMax : 100,
      title: {
        text: "Apex Packs",
      },
    },
  };

  const seriesMap = [];

  seriesMap.push({
    name: "Account",
    color: COLORS.RED,
    data: [parseInt(accountPacks)],
    dataLabels: {
      enabled: parseInt(accountPacks) >= 5 ? true : false,
    },
  });

  if (!!twitchPrime) {
    seriesMap.push({
      name: "Twitch Packs",
      color: COLORS.TWITCH,
      data: [5],
      dataLabels: {
        enabled: true,
      },
    });
  }

  // all seasons
  BATTLEPASSES_ORDERED.forEach((thisSeason, i) => {
    if (i === 0) return; // skip season 0 preseason

    // [seasonPacks]
    // this season's number of earned season packs
    const thisSeasonPacks = parseInt(seasonalPacks[i]);
    if (!!thisSeasonPacks) {
      seriesMap.push({
        name: `S${i}.${SEASONS_ORDERED[i].NAME}`,
        color: SEASONS_ORDERED[i].COLOR,
        data: [thisSeasonPacks],
        dataLabels: {
          enabled: thisSeasonPacks >= 5 ? true : false,
        },
      });
    }

    // [seasonQuestPacks]
    const thisSeasonalQuestPacks = parseInt(seasonalQuestPacks[i]);
    if (!!thisSeasonalQuestPacks) {
      seriesMap.push({
        name:
          SEASONS_ORDERED[i].QUEST === "treasurePacks"
            ? `S${i} Treasure Packs`
            : `S${i} Quest: ${SEASONS_ORDERED[i].QUEST}`,
        color: SEASONS_ORDERED[i].QUEST_COLOR,
        data: [thisSeasonalQuestPacks],
        dataLabels: {
          enabled: thisSeasonalQuestPacks >= 5 ? true : false,
        },
      });
    }

    // [seasonalLTMs]
    if (!!seasonalLTMs[i]) {
      seasonalLTMs[i].forEach((thisLTM, j) => {
        if (!!thisLTM) {
          seriesMap.push({
            name: LTMS[i][j].name,
            color: LTMS[i][j].bgColor,
            data: [parseInt(thisLTM)],
            dataLabels: {
              enabled: parseInt(thisLTM) >= 5 ? true : false,
            },
          });
        }
      });
    }
  });

  if (parseInt(purchasedPacks) !== null && parseInt(purchasedPacks) > 0) {
    seriesMap.push({
      name: "Purchases",
      color: COLORS.MONEY,
      data: [parseInt(purchasedPacks)],
      dataLabels: {
        enabled: parseInt(purchasedPacks) >= 5 ? true : false,
      },
    });
  }
  if (parseInt(miscPacks) !== null && parseInt(miscPacks) > 0) {
    seriesMap.push({
      name: "Misc Packs",
      color: COLORS.MISC,
      data: [parseInt(miscPacks)],
      dataLabels: {
        enabled: parseInt(miscPacks) >= 5 ? true : false,
      },
    });
  }

  config.series = seriesMap.reverse();

  // last heirloom line (if exists)
  if (heirloomRecord !== 0 && heirloomRecord !== undefined) {
    config.yAxis.plotLines.push({
      color: COLORS.HEIRLOOM,
      dashStyle: "dash",
      label: {
        text: "Last",
        style: {
          color: COLORS.HEIRLOOM,
          fontWeight: "bold",
        },
      },
      value: parseInt(heirloomRecord),
      width: 2,
      zIndex: 2,
    });
  }

  // user's progress line
  const adjustedPacks =
    heirloomRecord !== undefined && heirloomRecord !== 0
      ? totalPacks - heirloomRecord
      : totalPacks;
  config.yAxis.plotLines.push({
    color: "#666",
    label: {
      text: `Total Packs: ${totalPacks} (${Math.round(
        (adjustedPacks / 500) * 100
      )}%)`,
      style: {
        color: "#ccc",
        fontWeight: "bold",
      },
    },
    value: parseInt(totalPacks),
    width: 2,
    zIndex: 3,
  });

  return (
    <>
      <ReactHighcharts config={config} />
    </>
  );
};
